module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.4-135.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.4.md
// module id = 550
// module chunks = 245